import cuid from "cuid";
import { isEmpty, startCase } from "lodash";
import { SOCIAL_MEDIA_ENUM } from "../../../enums/socialMedia.enum";
import { i18n } from "../../../main";

export default {
  name: "IndicatorsData",
  props: {
    audit: {
      type: Object,
      default: () => {}
    },
    name: {
      type: String,
      default: ""
    }
  },

  computed: {
    formattedIndicators() {
      const arr = [];
      Object.entries(this.audit).map(([k, v]) => {
        if (k === "clients_activity_score") {
          arr.push({
            name: k,
            id: cuid(),
            value:
              v.last_value + " pkt" || v.last_value === 0
                ? v.last_value + " pkt"
                : "Brak danych",
            info:
              this.name === SOCIAL_MEDIA_ENUM.FACEBOOK
                ? i18n.t(
                    "message.visibility.socialMedia.facebook.clientsActivityInfo"
                  )
                : i18n.t(
                    "message.visibility.socialMedia.instagram.clientsActivityInfo"
                  ),
            type: this.setIndicatorColor(v.last_value)
          });
        }
        if (k === "user_activity_score") {
          arr.push({
            name: k,
            id: cuid(),
            value:
              v.last_value + " pkt" || v.last_value === 0
                ? v.last_value + " pkt"
                : "Brak danych",
            info:
              this.name === SOCIAL_MEDIA_ENUM.FACEBOOK
                ? i18n.t(
                    "message.visibility.socialMedia.facebook.userActivityInfo"
                  )
                : i18n.t(
                    "message.visibility.socialMedia.instagram.userActivityInfo"
                  ),
            type: this.setIndicatorColor(v.last_value)
          });
        }
      });

      Object.entries(this.audit.data).map(([k, v]) => {
        if (k === "about_info") {
          Object.entries(this.audit.data.about_info).map(([k, v]) => {
            if (k === "open_hours") {
              arr.push({
                name: k,
                id: cuid(),
                value: !isEmpty(v) ? "Dodano" : "Nie dodano",
                type: !isEmpty(v) ? "success" : "error"
              });
            } else {
              arr.push({
                name: k,
                id: cuid(),
                value: v.last_value ? "Dodano" : "Nie dodano",
                type: v.last_value ? "success" : "error"
              });
            }
          });
        } else if (k === "reviews") {
          Object.entries(this.audit.data.reviews).map(([k, v]) => {
            if (k === "reviews_rating") {
              arr.push({
                name: k,
                id: cuid(),
                value: v.last_value || "Brak",
                type: v.last_value && v.last_value > 3 ? "success" : "error"
              });
            } else {
              arr.push({
                name: k,
                id: cuid(),
                value: v.last_value || "Brak",
                type: v.last_value ? "success" : "error"
              });
            }
          });
        } else if (k !== "posts" && k !== "posts_info") {
          if (typeof v.last_value === "number") {
            arr.push({
              name: k,
              id: cuid(),
              value: v.last_value || "Brak",
              type: v.last_value && v.last_value > 3 ? "success" : "error"
            });
            return;
          }
          arr.push({
            name: k,
            id: cuid(),
            value: v.last_value ? "Dodano" : "Nie dodano",
            type: v.last_value ? "success" : "error"
          });
        }
      });

      return arr;
    }
  },

  methods: {
    setIndicatorColor(value) {
      if (!value || value < 41) return "error";
      if (value >= 41 && value < 75) return "orange";
      if (value >= 75) return "success";
    }
  },

  render() {
    return this.$scopedSlots.default({
      formattedIndicators: this.formattedIndicators
    });
  }
};
